(function ($) {

	/* Navigation Toggle
		 ========================================================================== */

	jQuery(document).on('click', '.navigation-toggle', function (event) {
		event.preventDefault();
		jQuery(this).toggleClass('navigation-toggle-active');
		jQuery('.navigation-collapse').toggleClass('navigation-open');
	});

	jQuery(document).ready(function ($) {

		/* Sticky Navigation
			 ========================================================================== */

		jQuery(window).on("load scroll resize", function () {
			var stickyWrapper = jQuery("#page");
			var stickyElement = jQuery("#masthead");
			var stickyClass = "sticky";
			var stickyScrolledClass = "sticky-scrolled";

			if (window.innerWidth > 1023 && jQuery(this).scrollTop() > 120) {
				stickyWrapper.addClass(stickyClass);
				stickyElement.addClass(stickyClass);
			} else {
				stickyWrapper.removeClass(stickyClass);
				stickyElement.removeClass(stickyClass);
			}

			if (window.innerWidth > 1023 && jQuery(this).scrollTop() > 120 + 1) {
				stickyElement.addClass(stickyScrolledClass);
			} else {
				stickyElement.removeClass(stickyScrolledClass);
			}
		});

		/* Telephone Links
			 ========================================================================== */

		jQuery('.tel[data-phone], .tel .value[data-phone]').each(function () {
			var tel = jQuery(this);
			var link = jQuery('<a/>');

			link.html(tel.html());
			link.attr('href', 'tel:' + tel.data('phone'));
			link.attr('class', tel.attr('class'));

			tel.replaceWith(link);
		});

		/* HTML5 Placeholder
			 ========================================================================== */

		// jQuery('input, textarea').placeholder();

		/* Slider
			 ========================================================================== */

		jQuery('[data-slick]').slick();

		jQuery('[data-slick]').on("beforeChange", function (event, slick) {
			var currentSlide, slideType, player, command;

			//find the current slide element and decide which player API we need to use.
			currentSlide = jQuery(slick.$slider).find(".slick-current");

			//determine which type of slide this, via a class on the slide container.
			slideType = currentSlide.attr("class").split(" ")[1];

			//get the iframe inside this slide.
			player = currentSlide.find("iframe").get(0);

			if (slideType === "vimeo") {
				command = {
					"method": "pause",
					"value": "true"
				};
			} else {
				command = {
					"event": "command",
					"func": "pauseVideo"
				};
			}

			//check if the player exists.
			if (player !== undefined) {
				//post our command to the iframe.
				player.contentWindow.postMessage(JSON.stringify(command), "*");
			}
		});

		/* Match / Equal Height
			 ========================================================================== */

		/*jQuery(function() {
			$.fn.matchHeight._maintainScroll = true;
			jQuery('[data-equal-height]').matchHeight();
		});*/

		/* Video
			 ========================================================================== */

		jQuery('.video-overlay[data-video]').one('click', function () {
			jQuery(this).html('<iframe src="https://www.youtube.com/embed/' + jQuery(this).data("video") + '?enablejsapi=1&autoplay=1&rel=0" allowfullscreen></iframe>');
		});

		// jQuery(function () {
		// 	document.getElementById("playbutton").disabled = true;
		// 	var player = jQuery('iframe');
		// 	var playerOrigin = '*';
		// 	// Listen for messages from the player
		// 	if (window.addEventListener) {
		// 		window.addEventListener('message', onMessageReceived, false);
		// 	} else {
		// 		window.attachEvent('onmessage', onMessageReceived, false);
		// 	}

		// 	function onMessageReceived(event) {
		// 		var data = JSON.parse(event.data);
		// 		console.log(data.event);
		// 		if (data.event === "ready") {
		// 			//attach ready function to the image
		// 			document.getElementById("playbutton").disabled = false;

		// 			jQuery('#playbutton').click(function () {
		// 				player[0].contentWindow.postMessage({
		// 					"method": "play"
		// 				}, playerOrigin);
		// 				jQuery(this).remove();
		// 			});

		// 		}
		// 	}
		// });

		/* Tabset
			 ========================================================================== */

		var tabLinks = jQuery('[data-tab]');
		var tabContents = jQuery('[data-tab-content]');
		var tabLinkActive = '.tab-link.active';
		var tabLinkActiveClass = 'active';
		var tabActiveClass = 'active';

		jQuery('[data-tabset]').each(function () {
			var wrapper = jQuery(this);
			var group = wrapper.data('tab-group');
			var scope = '[data-tab-group=' + group + ']';
			var tabs = tabLinks.filter(scope);
			var content = tabContents.filter(scope);
			var init = wrapper.data('tab-init');

			//
			// Init Tab
			//

			jQuery('[data-tab]' + scope).each(function (index, a) {
				if (jQuery(a).attr('href') === window.location.hash) {
					// Do nothing
				}
				else {
					tabs.filter('[data-tab=' + init + ']').addClass(tabLinkActiveClass);
					content.filter('[data-tab-content=' + init + ']').addClass(tabActiveClass);
				}
			});

			//
			// Tabs
			//

			tabs.on('click', function (event) {
				var tab = jQuery(this);
				var activeTab = tab.data('tab');

				if (wrapper.hasClass('tabset-responsive') && window.innerWidth < 768) {
					tabs.filter('[data-tab=' + activeTab + ']').toggleClass(tabLinkActiveClass);
					content.filter('[data-tab-content=' + activeTab + ']').toggleClass(tabActiveClass).end();
				}
				else {
					tabs.removeClass(tabLinkActiveClass).filter('[data-tab=' + activeTab + ']').addClass(tabLinkActiveClass);
					content.removeClass(tabActiveClass).filter('[data-tab-content=' + activeTab + ']').addClass(tabActiveClass);
				}

				jQuery(window).on('load resize', function () {
					if (window.innerWidth > 767) {
						tabs.removeClass(tabLinkActiveClass).filter('[data-tab=' + activeTab + ']').addClass(tabLinkActiveClass);
						content.css('display', '').removeClass(tabActiveClass).filter('[data-tab-content=' + activeTab + ']').addClass(tabActiveClass);
					}
				}).resize();

				if (tab.hasClass('tab-link')) {
					event.preventDefault();
				}
				$.fn.matchHeight._update(); // Update match height
			});

			//
			// Pevious Tab
			//

			wrapper.on('click', '[data-tab-prev]' + scope, function (event) {
				for (var i = tabs.length - 1; i >= 0; i--) {
					var tab = tabs.eq(i);

					if (tab.is(tabLinkActive)) {
						tabs.eq(i - 1).trigger('click');

						break;
					}
				}

				$.fn.matchHeight._update(); // Update match height
				event.preventDefault();
			});

			//
			// Next Tab
			//

			wrapper.on('click', '[data-tab-next]' + scope, function (event) {
				for (var i = 0, last = tabs.length; i < last; i++) {
					var tab = tabs.eq(i);

					if (tab.is(tabLinkActive)) {
						tabs.eq((i + 1) % last).trigger('click');
						break;
					}
				}

				$.fn.matchHeight._update(); // Update match height
				event.preventDefault();
			});

			//
			// Hash Tab
			//

			jQuery(window).on('hashchange load', function () {
				jQuery('[data-tab]' + scope).each(function (index, a) {
					var tab = jQuery(this);
					var activeTab = tab.data('tab');

					if (jQuery(a).attr('href') === window.location.hash && window.location.href) {
						tabs.removeClass(tabLinkActiveClass).filter('[data-tab=' + activeTab + ']').addClass(tabLinkActiveClass);
						content.removeClass(tabActiveClass).filter('[data-tab-content=' + activeTab + ']').addClass(tabActiveClass);
						jQuery(document).scrollTop(jQuery(this).offset().top);

						$.fn.matchHeight._update(); // Update match height
					}
				});
			});
		});

		/* Accordion
			 ========================================================================== */

		var accordion = '[data-accordion]';
		var accordionHeader = '[data-accordion-header]';
		var accordionContent = '[data-accordion-content]';
		var accordionActiveClass = 'active';

		jQuery(accordion)
			.find(accordionContent).hide().end()
			.find(accordionHeader + ':first').addClass(accordionActiveClass).end()
			.find(accordionContent + ':first').show().end()
			.on('click', accordionHeader, function (event) {
				var self = jQuery(this);
				var accordionBody = self.closest(accordion);

				if (!self.hasClass(accordionActiveClass)) {
					accordionBody
						.find(accordionHeader).removeClass(accordionActiveClass).end()
						.find(accordionContent).slideUp().end();

					self.addClass(accordionActiveClass)
						.next(accordionContent).slideDown(function () {
							$.fn.matchHeight._update(); // Update match height
						}).end();
				}

				event.preventDefault();
			});

		/* Tooltip
			 ========================================================================== */

		jQuery('[data-tooltip]')
			.mouseenter(function () {
				var title = jQuery(this).attr('title');
				jQuery(this).attr('temp_title', title);
				jQuery(this).attr('title', '');
			})
			.mouseleave(function () {
				var title = jQuery(this).attr('temp_title');
				jQuery(this).attr('title', title);
			})
			.click(function () {
				var title = jQuery(this).attr('temp_title');
				jQuery(this).attr('title', title);
			});

		/* Gallery
			 ========================================================================== */

		jQuery('.gallery-thumbnail a').attr('rel', 'gallery');

		jQuery('.gallery a').fancybox({
			maxWidth: 760,
			maxHeight: '100%',
			fitToView: true,
			margin: 16,
			padding: 4,
			width: '100%',
			height: 'auto',
			autoSize: false,
			closeClick: false,
			openEffect: 'none',
			closeEffect: 'none',
			helpers: {
				thumbs: {
					width: 48,
					height: 48
				}
			}
		});

		/* Fancybox
			 ========================================================================== */

		jQuery('.fancybox').fancybox({
			maxWidth: 760,
			maxHeight: '100%',
			fitToView: true,
			margin: 16,
			padding: 0,
			width: '100%',
			height: 'auto',
			autoSize: false,
			closeClick: false,
			openEffect: 'none',
			closeEffect: 'none'
		});

		jQuery('.fancybox-package').fancybox({
			maxWidth: 704,
			maxHeight: '100%',
			fitToView: true,
			margin: 16,
			padding: 0,
			width: 704,
			height: 'auto',
			autoSize: false,
			closeClick: false,
			openEffect: 'none',
			closeEffect: 'none'
		});

	}); // end.ready

}(jQuery));